export const customStyles = {
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isSelected
      ? "#007BFF" // Selected option background color (blue)
      : isFocused
      ? "#F1F1F1" // Focused option background color (light gray)
      : "white", // Default option background color (white)
    color: isSelected ? "white" : "#333", // Text color based on selection
    padding: "10px 8px",
    cursor: "pointer",
    zIndex: "1000",
    "&:active": {
      backgroundColor: "#007BFF", // Active option background color
    },
  }),
  menu: styles => ({
    ...styles,
    backgroundColor: "#fff", // Ensure menu background is white
    borderRadius: "4px", // Optional: set rounded corners for the menu
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Optional: set a light shadow for the menu
  }),
  menuPortal: base => ({
    ...base,
    zIndex: 9999,
  }),
}
